import React, { useState } from "react";

const About = () => {
  const [toggleReadMore, setToggleReadMore] = useState(false);

  return (
    <div className="mt-10">
      {!toggleReadMore ? (
        <div className="px-16 text-center">
          <p className="mt-2">
            यंदाचे वर्षी आपली श्री शिव सह्याद्री संस्था १२ व्या वर्षात पदार्पण
            करत असताना आपल्या या शिवप्रेमी सामाजिक संस्थेच्या माध्यामतून श्री
            शिव राज्याभिषेकाचे दहावे वर्ष आहे.
          </p>
          <p className="mt-2">
            आपणा सर्वांनाच उत्सुकता असेलच कि,हि संस्था नक्की कोणत्या क्षेत्रात
            कार्यरत आहे ? हीच आपली उत्सुकता लक्षात घेऊन मी आज आपणास आपल्या या
            सामाजिक- शिवप्रेमी संस्थेचा अल्प परिचय करून देणार आहे.
          </p>
          <p className="mt-2">
            शालेय जीवनातून सुरु झालेला शिवप्रेमी म्हणून प्रवास अखेर सर्व
            शिवप्रेमी मित्र एकत्र येऊन त्याचे रूपांतर संघटनेत झाले.मुळातच आपल्या
            संस्थची सुरुवात २००७ पासूनची.
          </p>
          <p className="mt-2">
            पण संस्था नोंदणी मात्र २०१२ रोजी करण्यात आली तेव्हापासून संस्थेला
            अधिकृत सामाजिक संघटनेचे स्वरूप प्राप्त झाले.
          </p>
          <p className="mt-2">
            संस्था म्हणून नावारूपाला यायच्या आधीपासूनच गड दुर्ग भ्रमंती अर्थात
            ट्रेकिंग , निसर्ग निगडीत वृक्षरोपण कार्यक्रम सुरुवातीपासून सुरु
            होते. त्याच वर्षी पदिवाली मध्ये दुर्ग (किल्ले) बांधणी स्पर्धेच्या
            निमित्ताने असंख्य बाल मित्रे जोडली गेली ती आजही संस्थेच्या कार्यात
            कार्यरत आहेत.
          </p>
          <p className="cursor-pointer" onClick={() => setToggleReadMore(!toggleReadMore)}>Read More..</p>
        </div>
      ) : (
        <div className="px-16 text-center">
          <p className="mt-2">
            यंदाचे वर्षी आपली श्री शिव सह्याद्री संस्था १२ व्या वर्षात पदार्पण
            करत असताना आपल्या या शिवप्रेमी सामाजिक संस्थेच्या माध्यामतून श्री
            शिव राज्याभिषेकाचे दहावे वर्ष आहे.
          </p>
          <p className="mt-2">
            आपणा सर्वांनाच उत्सुकता असेलच कि,हि संस्था नक्की कोणत्या क्षेत्रात
            कार्यरत आहे ? हीच आपली उत्सुकता लक्षात घेऊन मी आज आपणास आपल्या या
            सामाजिक- शिवप्रेमी संस्थेचा अल्प परिचय करून देणार आहे.
          </p>
          <p className="mt-2">
            शालेय जीवनातून सुरु झालेला शिवप्रेमी म्हणून प्रवास अखेर सर्व
            शिवप्रेमी मित्र एकत्र येऊन त्याचे रूपांतर संघटनेत झाले.मुळातच आपल्या
            संस्थची सुरुवात २००७ पासूनची.
          </p>
          <p className="mt-2">
            पण संस्था नोंदणी मात्र २०१२ रोजी करण्यात आली तेव्हापासून संस्थेला
            अधिकृत सामाजिक संघटनेचे स्वरूप प्राप्त झाले.
          </p>
          <p className="mt-2">
            संस्था म्हणून नावारूपाला यायच्या आधीपासूनच गड दुर्ग भ्रमंती अर्थात
            ट्रेकिंग , निसर्ग निगडीत वृक्षरोपण कार्यक्रम सुरुवातीपासून सुरु
            होते. त्याच वर्षी पदिवाली मध्ये दुर्ग (किल्ले) बांधणी स्पर्धेच्या
            निमित्ताने असंख्य बाल मित्रे जोडली गेली ती आजही संस्थेच्या कार्यात
            कार्यरत आहेत.
          </p>
          <p className="mt-2">
            एक शिवप्रेमी संस्था म्हणून सर्वात मोठी जबाबदरी पार पाडली ती पनवेल
            बंदरातील शिवकालीन तोफांचा शोध लाऊन त्यांचे शासकीय परवानगी घेऊन
            उत्खनन करणे आणि त्याना योग्य ठिकाणी बसविणे. हा उपक्रम संस्थेने
            सामजिक ,राजकीय मित्रांच्या मदतीने पूर्ण केला.आज या ऐतिहासिक तोफा
            पनवेल महानगरपालिकेच्या आवारात सुसज्ज स्थितीत व देखरेखीखाली सुरक्षित
            आहेत.
          </p>
          <p className="mt-2">
            दिवाळी निमित्त दर वर्षी आदिवासी बांधवाना फराळ, कपडे वाटप उपक्रम.
            आदिवासी वाडीवरील विद्यार्थ्याना शालेयउपयोगी साहित्य व दप्तर वाटपाचे
            उपक्रम संस्थेने केलेले आहेत.
          </p>
          <p className="mt-2">
            पनवेल जवळील किल्ले कर्नाळा वर २००८ ते २०१३ पर्यंत दुर्ग स्वच्छता
            अभियान राबउन गडावरील काचा,प्लास्टिक, पाण्याच्या टाक्या,गडावरील
            पायवाटा,कर्णाई देवीचे मंदिर स्वच्छ करणे आणि काही ऐतिहासिक मूर्तींचा
            शोध लाऊन त्या सुखरूप बाहेर काढल्या( २०१३)
          </p>
          <p className="mt-2">
            किल्ले प्रबळगड हा देखील आपल्या पनवेलच्या अगदी जवळ असणारा किल्ला.
          </p>
          <p className="mt-2">
            या किल्ल्यावर प्रत्यक्ष शिवराय येऊन गेलेत असा दैदिप्त्य्मान वारसा
            लाभेलेला किल्ला आपल्या परिसरात आहे हेच आपले पनवेल वासियांचे भाग्य
            म्हणावे लागेल. या किल्ल्यावर आजपर्यंत आपल्या संस्थेने व सोबत इतर
            शिवप्रेमी संस्था मिळून साधारण १७० हून अधिक संवर्धन व स्वच्छता मोहिमा
            घेऊन दुर्गाची अविरत सेवा केली व ती आजही सुरु आहे.त्यात दुर्गावरील
            पायवाटा ,मार्गदर्शक फलक, पाण्याचे टाके साफ करणे, ३० व ३१ डिसेंबर
            रोजीच्या दारू पार्टी विरोधी आंदोलने संस्थेने मागील ८ – ९ वर्षे
            यशस्वीरीत्या राबवले व त्याला चागलेच यश मिळाले.
          </p>
          <p className="mt-2">
            माची प्रबळगडा वर राहणाऱ्या ठाकर व आदिवासी समूहाच्या नागरिकांना
            दुर्गावर येणाऱ्या पर्यटकांच्या माध्यमातून व्यवसाय उपलब्ध व्हावा
            म्हणून संयुक्त वन व्यवस्थापन आणि आपल्या श्री शिव सह्याद्री
            संस्थेच्या माध्यमातून पर्यटक गाईड मार्गदर्शन शिबीर लाऊन त्यातून अनेक
            मार्गदर्शक घडवण्यात आले.आजरोजी माची प्रबळ वाडीत २० हून अधिक गाईड
            तयार झालेले असून त्याचे सारे श्रेय संस्थेच्या उपक्रमास जाते. त्याच
            बरोबर किल्ल्यावर आणि परिसारत होणारा प्लास्ती कचरा यावर बंदीं आणून
            संयुक्त वन व्यवस्थापनाच्या माध्यमातून संस्थेने येणाऱ्या पर्यटक यांना
            शुक आकारून प्लास्ती तपासणी करून मोठ्या प्रमाणावर होणारा प्लास्टिक
            कचरा आटोक्यात आणला. त्यामुळे स्थानिक नागरिकाना दुर्गाचे महत्व व
            पावित्र्य सामून आले व आता दुर्गाची देखभाल करण्यास ते सक्षम झाले
            आहेत.
          </p>
          <p className="mt-2">
            प्रबळगड किल्ल्याच्या मार्गावर संस्थेने २०० हून अधिक जंगली झाडे लावली
            आणि ती वाढवली हे विशेष.
          </p>
          <p className="mt-2">
            आपल्या रायगड जिल्ह्यातील गड दुर्गांचे शास्त्रीय पद्धतीने जतन आणि
            संवर्धन व्हावे यासाठी तत्कालीन रायगड जिल्ह्याचे जिल्हाधिकारी यांच्या
            अध्यक्षतेखाली “रायगड जिल्हा किल्ले संवर्धन आणि पर्यटन समिती” ची
            स्थापना करण्यात आली. हि समिती आपल्या संस्थेच्या प्रयत्नातून
            पूर्णत्वास गेली. आजही आपल्या संस्थेतील पदधिकारी या समितीवर कार्यरत
            आहेत. या समितीच्या माध्यमातून रायगड जिल्ह्यातील किल्ल्यांवर काम
            करणाऱ्या अनेक शिवप्रेमी संस्था या समितीच्या अंतर्गत येऊन नियीजीत
            कार्य करत आहेत.
          </p>
          <p className="mt-2">
            महिला व बाल सशक्ती कारणासाठी मर्दानी लाठी काठी प्रशिक्षण शिबिरांचे
            आयोजन संस्थेच्या माध्यामतून राबवण्यात आली त्याचा अनेकांनी लाभ घेतला.{" "}
          </p>
          <p className="mt-2">
            संस्थेने छत्रपती शिवरायांच्या विचारांवर संघटीत होणाऱ्या तरुणांना व
            पनवेल मधील नागरिकाना शिवचरित्र समजावे आणि त्यातून सामाजिक संस्कार
            घडावेत या साठी पनवेल मधील अस्वारूढ श्री शिवाजी महाराच्या पुतळ्यासमोर
            दर सोमवारी शिववंदना घेतली जाते. या शिव वंदनेला यावर्षी १३ वर्ष पूर्ण
            होत आहेत. या ठिकाणी शिवरायांच्या विचाराशी समविचारी मंडळी जमतात आणि
            सामाजिक प्रश्न उत्तरे यांचा तास व शिव चरित्रावर व्याखाय्न नियमित
            सुरु असतात.
          </p>
          <p className="mt-2">
            अश्याच उपक्रमापैकी एक महत्वाचा उपक्रम म्हणजे आजचे निमित श्री शिव
            राज्याभिषेक दिन सोहळा.
          </p>
          <p className="mt-2">
            आज पासून मागे १० वर्षापूर्वी या सोहळ्यास सुरुवात करण्यात आली.
            छत्रपती शिवराय युगप्रवर्तक छत्रपती बनणार अस हा दिवस अखिल
            हिंदुस्थानचा सुवर्ण दिन . याच दिवशी शिवाजी महाराज अधिकृत चक्रवर्ती
            छत्रपती झाले. शिवरायांनी निर्माण केलेली आदर्श राज्यमंडळ , न्याय मंडळ
            , मराठी भाषेत घुसलेले अरबी - फारशी शब्द काढून, ‘”मराठी राजभाषा कोष”
            त्यांनी राज्याभिषेक प्रसंगी अमात्यांच्या कडून तयार करून घेतला ,
            तेव्हाच मराठी भाषेला राजभाषेचा दर्जा दिला व मराठीला भाषेला अजरामर
            केले.
          </p>
          <p className="mt-2">
            त्यामुळे शिवरायांच्या दूरदृष्टीला स्मरण म्हणून आजच्या सारखा हा श्री
            शिव राज्याभिषेक दिन सोहळा आपल्या संस्थेने सुरु केला.
          </p>
          <p className="mt-2">
            त्याच निमित्ताने आज आपण सर्व भेटलो आणि संस्थेच्या उपक्रमांची माहिती
            आपणापर्यंत पोहोचविण्याची संधी देखील त्यानिमित्त मिळाली हे आमचे परम
            भाग्य म्हणावे लागेल.
          </p>
          <p className="mt-2">
            आपली संस्था आणि सहकारी संस्था मिळून भविष्यात देखील शिव छत्रपतींचे
            दुर्गांची सेवा अविरत करत राहणार. आपणही या उपक्रमात सहभागी होऊन
            स्वराज्य कार्यात सहभागी होऊन शिवरायांच्या कार्याला मानवंदना द्यावी
            अहि आग्रहाची सर्वाना विनंती!
          </p>
          <p className="cursor-pointer" onClick={() => setToggleReadMore(!toggleReadMore)}>Read less..</p>
        </div>
      )}
    </div>
  );
};

export default About;
